module.exports = __webpack_public_path__ + "img/8.6d445f46.gif";